import { FaArrowRight } from "react-icons/fa";

const Forefront = () => {
  return (
    <div className="w-full px-6 py-10 text-black bg-white md:px-12 lg:px-24">
      {/* Heading */}
      <div className="max-w-3xl mx-auto text-center">
        <h1 className="mb-4 text-[42px] font-medium leading-[48px] md:text-5xl text-[#0f0f0f]">
          At the forefront of Crypto
        </h1>
        <p className="text-base text-gray-600 md:text-lg">
          Since 2018, Chorus One has been the torchbearer of Proof-of-Stake and
          offers battle-tested staking infrastructure among other services.
        </p>
      </div>

      {/* Cards Section */}
      <div className="grid max-w-6xl grid-cols-1 gap-6 mx-auto mt-12 md:grid-cols-3">
        {/* Card 1 */}
        <div className="p-6 transition bg-white border shadow-lg rounded-2xl hover:shadow-xl">
          <h3 className="mb-3 text-[32px] leading-[40px] font-medium text-[#0f0f0f]">
            Enterprise Staking
          </h3>
          <p className="mb-4 text-[#4e4e4e] text-[19px] leading-[24px] font-normal">
            The world's biggest digital asset companies trust us to set up their
            staking infrastructure through our tailor-made offerings.
          </p>
          <button className="flex items-center p-2 text-black transition border border-black rounded-full hover:translate-x-1">
            <FaArrowRight size={20} />
          </button>
        </div>

        {/* Card 2 */}
        <div className="p-6 transition bg-white border shadow-lg rounded-2xl hover:shadow-xl">
          <h3 className="mb-3 text-[32px] leading-[40px] font-medium text-[#0f0f0f]">
            Public Nodes
          </h3>
          <p className="mb-4 text-[#4e4e4e] text-[19px] leading-[24px] font-normal">
            Over 100 thousand people stake to our public nodes on 40+ networks
            including Ethereum, Cosmos, Celestia, Solana, Avalanche, and NEAR.
          </p>
          <button className="flex items-center p-2 text-black transition border border-black rounded-full hover:translate-x-1">
            <FaArrowRight size={20} />
          </button>
        </div>

        {/* Card 3 */}
        <div className="p-6 transition bg-white border shadow-lg rounded-2xl hover:shadow-xl">
          <h3 className="mb-3 text-[32px] leading-[40px] font-medium text-[#0f0f0f]">
            Chorus Ventures
          </h3>
          <p className="mb-4 text-[#4e4e4e] text-[19px] leading-[24px] font-normal">
            TA $30m investment fund for some of the most innovative PoS
            networks, interoperability networks and middleware protocols.
          </p>
          <button className="flex items-center p-2 text-black transition border border-black rounded-full hover:translate-x-1">
            <FaArrowRight size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Forefront;
